/**
 * Parses the json and returns parsed data if parsed successfully
 *
 * @type {<T>(json: string, def?: T) => T}
 */
export const parse = (json, def = json) => {
	if (typeof json !== "string") return def;
	try {
		return JSON.parse(json);
	} catch (err) {
		return def;
	}
};

/**
 * Stringifies data to json
 *
 * @type {<T>(data: T) => string}
 */
export const stringify = data => JSON.stringify(data, null, process.ENV !== "production" ? 2 : 0);
